module.exports = __webpack_public_path__ + "static/media/info-icon.d7f1a22b.svg";